export default (url: string, oldTail: string, newTail: string) => {
  const regexp = new RegExp(`/${ oldTail || '' }$`);

  return url.split('?')[0].replace(regexp, '') + (newTail ? `/${ newTail }` : '');
};
